import React from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { GlobalAlert } from '../../../global/components/GlobalAlert';

export const CategoryModal = ({
  show,
  onHide,
  modalMode,
  catFormData,
  setCatFormData,
  handleCatSubmit,
  error,
  setError
}) => {
  return (
    <Modal show={show} onHide={onHide} centered size="sm">
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title style={{ color: "#1e3c72", fontWeight: 700 }}>
          {modalMode === "add" ? "Add Category" : "Edit Category"}
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleCatSubmit}>
        <Modal.Body>
          <GlobalAlert message={error} onClose={() => setError("")} />
          <Form.Group>
            <Form.Label>Category Name</Form.Label>
            <Form.Control 
              type="text" 
              required 
              value={catFormData.name} 
              onChange={(e) => setCatFormData({...catFormData, name: e.target.value})} 
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0 mt-3">
          <Button variant="light" onClick={onHide}>Cancel</Button>
          <Button variant="primary" type="submit" style={{ background: "#1e3c72" }}>Save</Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};
